import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import { SEOHead } from '@/components/SEOHead';

export default function NotFound() {
  return (
    <>
      <SEOHead title="Page Not Found" description="The page you are looking for does not exist." noIndex />
      <div className="min-h-[70vh] flex items-center justify-center px-6">
        <div className="text-center max-w-lg">
          <div className="mb-8">
            <span className="font-mono text-8xl font-bold text-[#E5E7EB]">404</span>
          </div>
          <h1 className="font-serif text-3xl font-bold text-[#153E5C] mb-4">
            Page Not Found
          </h1>
          <p className="text-[#6B7280] font-sans text-base mb-8 leading-relaxed">
            The page you are looking for may have been moved, removed, or does not exist.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-[#0E5A57] hover:bg-[#2E7D7A] text-white font-semibold px-6 py-3 rounded-full transition-colors duration-200 text-sm"
            >
              <Home className="w-4 h-4" />
              Back to Homepage
            </Link>
            <Link
              to="/services"
              className="inline-flex items-center gap-2 border border-[#E5E7EB] text-[#374151] hover:bg-[#F7FAFC] font-medium px-6 py-3 rounded-full transition-colors duration-200 text-sm"
            >
              <ArrowLeft className="w-4 h-4" />
              View Services
            </Link>
          </div>
          <div className="mt-12 pt-8 border-t border-[#E5E7EB]">
            <p className="text-sm text-[#9CA3AF] font-sans mb-4">Looking for something specific?</p>
            <div className="flex flex-wrap justify-center gap-2">
              {['/about', '/contact', '/insights', '/case-experience'].map(path => (
                <Link key={path} to={path}
                  className="text-sm text-[#0E5A57] hover:text-[#153E5C] font-medium capitalize font-sans">
                  {path.replace('/', '').replace('-', ' ').replace('case-experience', 'Case Experience').replace(/(^\w|\s\w)/g, c => c.toUpperCase())}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
